import { render, staticRenderFns } from "./Base404.vue?vue&type=template&id=3a9170fa&scoped=true"
import script from "./Base404.vue?vue&type=script&lang=js"
export * from "./Base404.vue?vue&type=script&lang=js"
import style0 from "./Base404.vue?vue&type=style&index=0&id=3a9170fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9170fa",
  null
  
)

export default component.exports